import { IIndicators } from "../../types/Indicators.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";

const API_URL = `${import.meta.env.VITE_API_URL}/indicators`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function createLeadByAmbassador(leadData) {
  const url = `${API_URL}/create-leads`;
  const data = {
    ...leadData,
    references: [
      { name: "-", content: "-", verified: false },
      { name: "-", content: "-", verified: false },
      { name: "-", content: "-", verified: false },
    ],
  };
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };
  const result = (await makeRequestDebounced(url, options)) as Promise<
    ApiResponseType<IIndicators>
  >;

  return result;
}

export async function registerIndicator(dataToSave) {
  const url = `${API_URL}/create`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(dataToSave),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<IIndicators>
  >;
}


export async function getAmbassadorByEmail(email: string) {
  const url = `${API_URL}/email/${email}`;

  const result = (await makeRequestDebounced(url)) as Promise<
    ApiResponseType<IIndicators>
  >;

  return result;
}

export async function getAmbassadorByCode(code: string) {
  const url = `${API_URL}/code/${code}`;

  const result = (await makeRequestDebounced(url)) as {
    ok: string;
    data: {
      cpf: string;
      name: string;
    };
  };

  return result.data;
}

export async function checkIsAmbassador(auth) {
  if (!auth || !auth.user || !auth.user.roles) {
    return false;
  }
  return auth.user.roles.length === 1 && auth.user.roles.includes("ambassador");
}
